<form [formGroup]="questionForm">
  <div id="question-{{ question.id }}" class="row">
    <div class="col-sm-1">
    <label>{{ question.section }}.{{ question.id }}</label>
    </div>
    <div class="col-sm-3">
    <label>{{ question.title }}</label>
    </div>
    <div *ngIf="isRiskFirst()" class="col-sm-{{ sizeRiskRewardCols() }}">
    <div class="row">
    <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideRisk()">
      <select
        #selectrisk
        formControlName="risk" [compareWith]="compareRiskRewardFn"
        (change)="onRiskChanged(selectrisk.value)"
        class="form-control questionrisk">
        <option *ngFor="let risk of risks" [ngValue]="risk.id">
          {{ risk.title }}
        </option>
      </select>
    </div>
    <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideReward()">
      <select
        #selectreward
        formControlName="reward" [compareWith]="compareRiskRewardFn"
        (change)="onRewardChanged(selectreward.value)"
        class="form-control questionrisk">
        <option *ngFor="let reward of rewards" [ngValue]="reward.id">
          {{ reward.title }}
        </option>
      </select>
    </div>
    </div>
    </div>
    <div *ngIf="!isRiskFirst()"  class="col-sm-{{ sizeRiskRewardCols() }}">
    <div class="row">
    <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideReward()">
      <select
        #selectreward
        formControlName="reward" [compareWith]="compareRiskRewardFn"
        (change)="onRewardChanged(selectreward.value)"
        class="form-control questionrisk">
        <option *ngFor="let reward of rewards" [ngValue]="reward.id">
          {{ reward.title }}
        </option>
      </select>
    </div>
    <div class="col-sm-{{ sizeRiskRewardSelect() }}" [class.d-none]="hideRisk()">
      <select
        #selectrisk
        formControlName="risk" [compareWith]="compareRiskRewardFn"
        (change)="onRiskChanged(selectrisk.value)"
        class="form-control questionrisk">
        <option *ngFor="let risk of risks" [ngValue]="risk.id">
          {{ risk.title }}
        </option>
      </select>
    </div>
    </div>
    </div>
    <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-primary"
          (click)="onHelpClick()"
          i18n>BUTTON_HELP</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onNotesClick()"
          i18n>BUTTON_NOTES</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onFeedbackClick()"
          [class.d-none]="hideFeedback()"
          i18n>BUTTON_FEEDBACK</button>
    </div>
    <div class="col-sm-2">
        <input
          type="range"
          min='0'
          max='100'
          step="10"
          #progress
          (input)="OnProgressChange(progress.value)"
          class="form-control-range questionprogress"
          FormControlName="progress"
          value="{{ question.progress }}">
    </div>
  </div>

